<template>
    <form action="POST" @submit.prevent="handleRegisterForm()">
        <div class="row form-heading">
            <div class="col-lg-12">
                <h2>Zaloguj się</h2>
                <p>Nie posiadasz konta? <a href="/rejestracja" class="text-underline">Zarejestruj się &rarr;</a></p>
                <p>Jeżeli w ciągu ostatniego roku byłaś/eś uczestnikiem konferencji organizowanych przez Med Space, to Twoje konto już istnieje - zaloguj się korzystając z niego.</p>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <form-input label="E-mail" v-model="email" :modelValue="email" type="email" name="email" placeholder="E-mail" :error-messages="errorMessage"></form-input>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <form-input label="Hasło" v-model="password" :modelValue="password" type="password" name="password" placeholder="hasło" :error-messages="errorMessage"></form-input>
            </div>
        </div>
        <div class="row">
            <div class="col-lg-3">
                <a href="/password/reset" class="reminder">Nie pamiętasz hasła?</a>
            </div>
            <div class="col-lg-6">
                <vue-simple-spinner v-if="processing"></vue-simple-spinner>
                <button class="btn btn-primary" v-else>Zaloguj się</button>
            </div>
        </div>
    </form>
</template>
<script>
import FormInput from "./formInput";
import Spinner from 'vue-simple-spinner';

export default {
    components: {
        FormInput,
        Spinner,
    },
    data() {
        return {
            email: '',
            password: '',
            remember: '',
            processing: '',
            errorMessage: null,
        }
    },

    methods: {
        handleRegisterForm() {
            axios.post('/api/login', {
                email: this.email,
                password: this.password,
                remember: this.remember
            })
                .then(response => {
                    this.processing = true;
                })
                .then(response => {
                    this.processing = false;
                    axios.post('/api/user-has-access').then(response => {
                        if (response.data.hasAccess){
                            window.location.href = '/';
                        } else {
                            window.location.href = '/profil';
                        }
                    }).catch(error => {
                        this.errorMessage = error.response.data.errors;
                    })
                })
                .catch(error => {
                    this.errorMessage = error.response.data.errors;
                })
                .then(error => {
                    window.scrollTo(document.querySelector('.error').offsetTop, 0);
                });
        }
    }

}

</script>
